<template>
  <b-row class="justify-content-center" no-gutters>
    <b-col cols="12" sm="8" md="6" lg="4" xl="4" class="fit-to-screen bg-white">
      <div class="w-100 bg-white fit-to-screen">
        <div class="w-100 py-5 px-4" v-if="error != ''">
          <ErrorMessage :message="error" />
        </div>
        <template v-else>
          <span id="top-section"></span>
          <!-- NAVBAR -->
          <div class="w-100 position-sticky bg-white border-form py-3 z-index-1041" style="top:0px;">
            <div class="ga-container py-2">
              <div class="d-flex">
                <div class="lh-1 align-self-center mr-3">
                  <svg @click="goToPage('PosHome')" class="lh-1 cursor-pointer" width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_581_18)">
                      <path
                        d="M0.0294189 8.00744C0.0294189 8.27112 0.145437 8.5137 0.356381 8.7141L7.35969 15.7069C7.57064 15.9073 7.79213 16.0022 8.04526 16.0022C8.56207 16.0022 8.97341 15.6225 8.97341 15.0951C8.97341 14.842 8.87848 14.5889 8.70973 14.4306L6.34717 12.0259L2.1705 8.21839L1.949 8.7352L5.34519 8.94614H18.6874C19.2358 8.94614 19.6155 8.5559 19.6155 8.00744C19.6155 7.45899 19.2358 7.06874 18.6874 7.06874H5.34519L1.949 7.27969L2.1705 7.80705L6.34717 3.98898L8.70973 1.58422C8.87848 1.41546 8.97341 1.17288 8.97341 0.919749C8.97341 0.392393 8.56207 0.0126953 8.04526 0.0126953C7.79213 0.0126953 7.57064 0.0970726 7.3386 0.32911L0.356381 7.30079C0.145437 7.50118 0.0294189 7.74376 0.0294189 8.00744Z"
                        fill="black" fill-opacity="0.85" />
                    </g>
                    <defs>
                      <clipPath id="clip0_581_18">
                        <rect width="19.5861" height="16" fill="white" transform="translate(0.0294189 0.0126953)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="lh-1 align-self-center">
                  <p class="body-1-4 mb-0">{{ payment_in_page ? 'Payment' : 'Cart' }}</p>
                </div>
              </div>
            </div>
          </div>
          <block :height="10" />
    
          <template v-if="!payment_in_page">
            <!-- ORDER SUMMARY -->
            <div class="ga-container">
              <p class="mb-4 body-1-4">Order Summary</p>
              <div class="mb-4">
                <div class="w-100" v-for="(product,product_i) in getOutletTrxProducts">
                  <ProductCart :data="product" :product_index="product_i" />
                </div>
              </div>
    
              <div class="w-100 border-orange p-3 radius-6" id="add_menu_section">
                <div class="row no-gutters">
                  <div class="col-9 align-self-center">
                    <div class="pr-3">
                      <p class="mb-0 body-2-1">Add more to your order?</p>
                      <p class="mb-0 body-3-3-1">Discover diverse and delicious options</p>
                    </div>
                  </div>
                  <div class="col-3 align-self-center">
                    <button class="g-btn g-btn-secondary g-btn-sm w-100" @click="goToPage('PosHome')">Add More</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>
    
            <!-- GUEST INFO -->
            <div class="ga-container">
              <p class="mb-0 body-1-4">Personalize Your Order, Note by Note!</p>
              <p class="mb-3 body-3-3-1">Add your name, table number, and special requests for a perfect meal!</p>
              <GuestForm ref="order_guest_form" type="ORDER"  />
              <span id="middle_section"></span>
            </div>
            <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>
    
            <template v-if="general_data.use_delivery">
              <!-- SERVE OPTION -->
              <div class="ga-container">
                <p class="mb-0 body-1-4">Choose Your Dining Preference</p>
                <p class="mb-3 body-3-3-1">Indicate whether you prefer delivery or on-site dining.</p>
                <div class="w-100">
                  <div class="w-100 mb-3 radius-6 cursor-pointer position-relative" v-for="(serve,serve_i) in serve_option.list" :id="serve.id" @click="serveOptionSelect(serve)" :class="serve.id != serve_option.selected.id ? 'border-form' : 'border-green'">
                    <div class="d-flex align-items-center py-2 z-index-1026">
                      <div class="px-3 text-center">
                        <svg v-if="serve.id != serve_option.selected.id" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10Z"
                            fill="#222222" />
                        </svg>
                        <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z" class="fill-primary"/>
                        </svg>
                      </div>
                      <div>
                        <div class="w-100 pr-3">
                          <p class="mb-0 body-2-1">{{ serve.title }}</p>
                          <p class="mb-0 body-3-3-1">{{ serve.subtitle }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="primary-overlay z-index-1025 radius-6" v-if="serve.id == serve_option.selected.id"></div>
                  </div>
                </div>
              </div>
              <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>
              
              <!-- DELIVERY INFORMATION -->
              <template v-if="serve_option.selected.id == 'delivery'">
                <div class="ga-container">
                  <p class="mb-0 body-1-4">Ensure Your Order Reaches You!</p>
                  <p class="mb-3 body-3-3-1">Provide your delivery address for a seamless experience.</p>
                  <p class="mb-3 body-2 text-danger" v-if="serve_option.error != ''">{{ serve_option.error }}</p>
                  <Delivery ref="delivery_section" page_module="CUSTOM_POS" :pos_id="general_data.id" />
                </div>
                <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>
              </template>
            </template>
    
            <!-- PROMO CODE -->
            <div class="ga-container">
              <p class="mb-0 body-1-4">Apply Promo Code</p>
              <p class="mb-3 body-3-3-1">Enter your code to unlock special offers.</p>
              <PromoCode :general_data="general_data" />
            </div>
            <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>
    
            <!-- PRICE DETAIL -->
            <div class="ga-container">
              <p class="mb-0 body-1-4">Price Details</p>
              <p class="mb-3 body-3-3-1">Review the cost breakdown before finalizing.</p>
              <div class="row slim-grid-row mb-2">
                <div class="col-7 align-self-center">
                  <p class="mb-0 body-2-1">Subtotal</p>
                </div>
                <div class="col-5 text-right align-self-center">
                  <p class="mb-0 font-lato text-14">{{ $formatCurrency(getOutletTrxSubTotal) }}</p>
                </div>
              </div>
              <div class="row slim-grid-row mb-2">
                <div class="col-6">
                  <p class="mb-0 body-2-1">Discount</p>
                </div>
                <div class="col-6 text-right">
                  <p class="mb-0 font-lato text-14" :class="{'text-green': getOutletTrxPromotion > 0}">- {{ getOutletTrxPromotion > 0 ? $formatCurrency(getOutletTrxPromotion) : '' }}</p>
                </div>
              </div>
              <div class="row slim-grid-row mb-2">
                <div class="col-7 align-self-center">
                  <p class="mb-0 body-2-1">Taxes & Services</p>
                </div>
                <div class="col-5 text-right align-self-center">
                  <p class="mb-0 font-lato text-14">{{ $formatCurrency(getOutletTrxTaxService) }}</p>
                </div>
              </div>
              <div class="row slim-grid-row mb-2" v-if="getOutletTrxDelivery.use && serve_option.selected.id == 'delivery'">
                <div class="col-7 align-self-center">
                  <p class="mb-0 body-2-1">Delivery Fee</p>
                </div>
                <div class="col-5 text-right align-self-center">
                  <p class="mb-0 font-lato text-14">{{ getOutletTrxDelivery.inquiry.delivery_fee ?  $formatCurrency(getOutletTrxDelivery.inquiry.delivery_fee) : '0' }}</p>
                </div>
              </div>
              <div class="row slim-grid-row mb-2" v-if="payment_surcharge > 0">
                <div class="col-7 align-self-center">
                  <p class="mb-0 body-2-1">Payment Surcharge</p>
                </div>
                <div class="col-5 text-right align-self-center">
                  <p class="mb-0 font-lato text-14">{{ $formatCurrency(payment_surcharge) }}</p>
                </div>
              </div>
              <div class="border-b-semi-grey-dashed-2 w-100 my-3"></div>
              <div class="row slim-grid-row" id="for-payment-section">
                <div class="col-6">
                  <p class="mb-0 body-1-4">Total</p>
                </div>
                <div class="col-6 text-right">
                  <p class="mb-0 font-lato text-16">{{ $formatCurrency(total_price) }}</p>
                </div>
              </div>
            </div>
            <div class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>
            
            <!-- PAYMENT -->
            <div class="ga-container" v-if="!is_load">
              <template v-if="!getOutletTrxDelivery.use">
                <template v-if="general_data.payment_mode == 'PAY_LATER'">
                  <p class="mb-0 body-1-4">Payment</p>
                  <p class="mb-3 body-3-3-1">Enjoy your meal now, settle the bill later.</p>
                </template>
                <template v-if="general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER'">
                  <p class="mb-0 body-1-4">Payment Options</p>
                  <p class="mb-3 body-3-3-1">Choose how you'd like to settle.</p>
                  <div class="w-100">
                    <div class="w-100 mb-3 radius-6 cursor-pointer position-relative" v-for="(p_mode,p_mode_i) in payment_mode.list" :id="p_mode.id" @click="paymentModeSelect(p_mode)" :class="p_mode.id != payment_mode.data.id ? 'border-form' : 'border-green'">
                      <div class="row no-gutters align-items-center py-2 z-index-1026">
                        <div class="col-2 text-center">
                          <svg v-if="p_mode.id != payment_mode.data.id" width="20" height="20" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM2 10C2 14.42 5.58 18 10 18C14.42 18 18 14.42 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10Z"
                              fill="#222222" />
                          </svg>
                          <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10Z" class="fill-primary"/>
                          </svg>
                        </div>
                        <div class="col-10">
                          <div class="w-100 pr-3">
                            <p class="mb-0 body-2-1">{{ p_mode.title }}</p>
                            <p class="mb-0 body-3-3-1">{{ p_mode.description }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="primary-overlay z-index-1025 radius-6" v-if="p_mode.id == payment_mode.data.id"></div>
                    </div>
                  </div> 
                  <p class="mb-0 mt-2 body-2 text-danger" v-if="validate_payment.mode">Please select payment option</p>
                </template>
              </template>
              <div class="w-100 mb-4" :class="{'mt-4 border-t-semi-grey-dashed-2' : !this.getOutletTrxDelivery.use}" v-if="general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && payment_mode.data.id == 'PAY_IMMEDIATELY'"></div>
              <div class="w-100" v-if="general_data.payment_mode == 'PAY_IMMEDIATELY' || (general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && payment_mode.data.id == 'PAY_IMMEDIATELY')">
                <p class="mb-0 body-1-4">Payment Method</p>
                <p class="mb-3 body-3-3-1">Choose your preferred way to pay securely.</p>
                <div class="w-100">
                  <PaymentMethod ref="payment_method" module="concierge" :sub_module="general_data.code" @selectPayment="selectPayment" @doneLoad="paymentMethodDoneLoad"></PaymentMethod>
                </div>
              </div>
            </div>
            
            <!-- PAYMENT CONTACT DETAIL -->
            <template v-if="need_guest_data_for_payment">
              <div id="payment_guest_form" class="w-100 my-4" style="height: 8px;background-color: #EEE;"></div>
              <div class="ga-container">
                <p class="mb-0 body-1-4">Contact Detail</p>
                <p class="mb-3 body-3-3-1">Some payment methods require your contact information</p>
                <div class="w-100">
                  <GuestForm ref="payment_guest_form" type="PAYMENT"  />
                </div>
              </div>
            </template>
    
            <!-- SUBMIT BUTTON -->
            <block :height="10" />
            <div class="w-100 position-sticky bg-white border-form py-3" style="bottom: 0px">
              <div class="ga-container">
                <div class="row slim-grid-row mb-2"> 
                  <div class="col-12 mb-2 text-center" v-if="error_push != ''">
                    <p class="mb-0 body-2 text-danger">Error : {{ error_push }}</p>
                  </div>
                  <div class="col-6">
                    <p class="mb-0 body-1-4">Total</p>
                  </div>
                  <div class="col-6 text-right">
                    <p class="mb-0 font-lato text-16">{{ $formatCurrency(total_price) }}</p>
                  </div>
                </div>
                <state-button variant="primary" size="xl" block :click="submitForm">Place Order</state-button>
              </div>
            </div>
          </template>
    
          <div class="w-100 py-4 ga-container" id="payment_section" v-else>
            <XenditInputCC
              :tx_payment="tx_payment"
              module_page="CONCIERGE"
              submodule_page="CUSTOM_POS"
              @done="clearCart"
              @expired="goToHomepage">
            </XenditInputCC>
          </div>
        </template>
      </div>
    </b-col>
  </b-row>

</template>

<script>
  import {
    mapGetters,
    mapMutations
  } from 'vuex';
  import {
    get,
    post
  } from '@/services/index.js'
  import ProductCart from '@/components/hotel/concierge/pos/ProductCart';
  import GuestForm from '@/components/hotel/concierge/pos/GuestForm';
  import PromoCode from '@/components/hotel/concierge/pos/PromoCode.vue';
  import PaymentMethod from '@/components/general/payment/PaymentMethod';
  import XenditInputCC from '@/components/hotel/be/XenditInputCC';
  import Delivery from "@/components/general/Delivery";

  export default {
    components:{
      ProductCart,
      GuestForm,
      PromoCode,
      PaymentMethod,
      XenditInputCC,
      Delivery
    },
    data() {
      return {
        is_load: true,
        error: '',
        general_data: {},
        payment_mode: {
          list: [{
              id: 'PAY_IMMEDIATELY',
              title: 'Instant Payment',
              description: 'Securely pay now for swift confirmation.'
            },
            {
              id: 'PAY_LATER',
              title: 'Pay Later',
              description: 'Enjoy your meal now, settle the bill later.'
            }
          ],
          data: {}
        },
        payment_method: {
          list: [],
          data: {}
        },
        error_push: '',
        validate_payment:{
          mode: false,
          method: false
        },
        tx_inquiry: {},
        tx_payment: {},
        payment_in_page: false,
        reservation:{},
        serve_option:{
          list: [
            {id: 'dine_in',title: 'Dine In',subtitle: 'Savor the moment at our place.'},
            {id: 'delivery',title: 'Delivery',subtitle: 'Effortless dining, delivered to your door.'}
          ],
          selected: {},
          error: ''
        }
      }
    },
    metaInfo() {
      return {
        title: this.page_title,
        titleTemplate: this.getMetaTitleTemplate
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getOutletTrxCustomerDetail',
        'getOutletTrxProducts',
        'getOutletTrxSubTotal',
        'getOutletTrxPromotion',
        'getOutletTrxTaxService',
        'getOutletTrxTotal',
        'isReservationActive',
        'getReservationActive',
        'isMembershipRewardApplied',
        'getUpsellRef',
        'getOutletTrxPromoCode',
        'getOutletTrxTableNumber',
        'getOutletTrxDelivery',
        'getOutletTrxNotes',
        'getMetaTitleTemplate'
      ]),
      pos_code() {
        return this.$route.params.pos_code
      },
      total_product_cart(){
        return this.getOutletTrxProducts.length
      },
      need_payment(){
        let general_loaded = this.general_data.id
        let default_payment_now = this.general_data.payment_mode == 'PAY_IMMEDIATELY'
        let selected_paymnet_now = this.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode.data.id == 'PAY_IMMEDIATELY' 

        return general_loaded && (default_payment_now || selected_paymnet_now)
      },
      payment_surcharge(){
				let total = 0

				if(this.payment_method.data.id){
					if(this.payment_method.data.surcharge_type == 'PERCENT'){
						total = (this.getOutletTrxTotal/100)*this.payment_method.data.surcharge_value
					}else{
						total = this.payment_method.data.surcharge_value
					}
				}

				return total
			},
      delivery_fee(){
        let total = 0
        if(this.general_data.use_delivery && this.serve_option.selected.id == 'delivery' && this.getOutletTrxDelivery.inquiry.delivery_fee){
          total = this.getOutletTrxDelivery.inquiry.delivery_fee
        }
        return total
      },
      total_price(){
        return this.getOutletTrxTotal+this.payment_surcharge+this.delivery_fee
      },
      need_guest_data_for_payment(){
				let return_data = false
        let is_default_pm_immediately = this.general_data.payment_mode == 'PAY_IMMEDIATELY'
        let is_pm_selected_immediately = this.general_data.payment_mode == 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode.data.id == 'PAY_IMMEDIATELY'
        let is_payment_method_selected = this.payment_method.data.id
        
				if((is_default_pm_immediately || is_pm_selected_immediately) && is_payment_method_selected){
          return_data = true
				}
					
				return return_data
			},
      page_title(){
        if(this.general_data.id) return this.$isNotEmpty(this.general_data.tagline) ? this.general_data.tagline : this.general_data.name
        return ''
      }
    },
    watch:{
      total_product_cart(){
        if(this.total_product_cart == 0){
          this.goToPage('PosHome')
        }
      }
    },
    mounted(){
      if(this.total_product_cart > 0){
        setTimeout(() => {
          this.$smoothScroll('top-section')
        }, 100);
        this.loadFirstData() 
      }else{
        this.goToPage('PosHome')
      }
    },
    methods:{
      ...mapMutations(['setTrxOutletCustomerDetail','clearTrxOutletProduct','setTrxOutletDelivery','setTrxOutletDeliveryType','resetTrxOutletDelivery']),
      loadFirstData() {
        this.is_load = true
        let func_exe = [this.loadGeneralData()]
        if(this.isReservationActive){
          func_exe.push(this.loadDetailReservation())
        }
        Promise.all(func_exe).finally(() => {
          if(this.general_data.use_delivery){
            this.serve_option.selected = this.getOutletTrxDelivery.use ? this.serve_option.list[1] : this.serve_option.list[0]
            this.payment_mode.data = this.getOutletTrxDelivery.use ? this.payment_mode.list[0] : {}
          }
          this.is_load = false
        })
      },
      loadGeneralData() {
        return new Promise((success, fail) => {
          this.general_data = {}
          get("CORE_HOTEL", `merchant-pos/${this.pos_code}/general`, {
            merchant_id: this.getMerchant.id
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.general_data = res.data
              this.$validatePage('CONCIERGE',this.general_data).then(()=>success()).catch(()=>fail())
            } else {
              fail(res.message)
            }
          })
        })
      },
      loadDetailReservation(){
				return new Promise((success,fail)=>{
          get("CONCIERGE",`reservation/${this.getReservationActive.detail_id}`,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
						let res = response.data
            if(res.success){
							let resv = res.data
							if(this.$isReservationValid(resv)){
								this.reservation = resv
							} else{
								this.setReservationActive('reset')
							}
              success()
            }else{
              fail(res.message)
            }
          })
        })
			},
      goToPage(page) {
        let route = {
          name: page,
          params: {
            merchant_code: this.getMerchant.code,
            pos_code: this.pos_code
          }
        }
        this.$router.push(route)
      },
      goToHomepage(){
        this.goToPage('PosHome')
      },
      paymentModeSelect(pm){
        this.payment_mode.data = pm
        if(pm.id == 'PAY_IMMEDIATELY') {
          setTimeout(() => {
            this.$smoothScroll('PAY_LATER')
          }, 100);
        }
      },
      selectPayment(pm) {
        this.payment_method.data = pm
        setTimeout(() => {
          this.$smoothScroll('payment_guest_form')
        }, 300);
      },
      paymentMethodDoneLoad(){
        if(this.payment_mode.data.id == 'PAY_IMMEDIATELY' && !this.getOutletTrxDelivery.use) this.$smoothScroll('PAY_LATER')
      },
      clearCart(){
        this.clearTrxOutletProduct()
      },
      
      serveOptionSelect(serve){
        this.serve_option.selected = serve
        let use_delivery = serve.id == 'delivery'
        this.setTrxOutletDeliveryType(use_delivery)
        if(use_delivery){
          this.payment_mode.data = this.payment_mode.list[0]
          let is_map_selected = this.$isNotEmpty(this.getOutletTrxDelivery.address.latitude) && this.$isNotEmpty(this.getOutletTrxDelivery.address.longitude) 
          if(!is_map_selected){
            setTimeout(() => {
              this.$refs.delivery_section.toggleDelivery()
            }, 100);
          }
        }else{
          this.payment_mode.data = {}
        }
      },

      // SUBMIT
      getApiParams(type='inquiry'){ 
        let params = {}
        if(type == 'inquiry'){
          let getRoomId = () => {
            return this.isReservationActive && Object.keys(this.reservation.room).length > 0 ? this.reservation.room.id : ''
          }
          let customer_data = {
            first_name: this.getOutletTrxCustomerDetail.first_name,
            last_name: this.getOutletTrxCustomerDetail.last_name,
            table_number: this.getOutletTrxTableNumber,
            email: '',
            phone_number: ''
          }
          if(this.need_guest_data_for_payment){
           customer_data.email = this.getOutletTrxCustomerDetail.email
           customer_data.phone_number = this.getOutletTrxCustomerDetail.phone_number
          }
          
          params = {
            merchant_id: this.getMerchant.id,
            products:[],
            customer_detail: customer_data,
            room_id: getRoomId(),
            merchant_pos_id: this.general_data.id,
            notes: this.getOutletTrxNotes,
            region: '',
            device: this.$getDeviceType(),
            promo_code: this.getOutletTrxPromoCode,
            campaign_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'CAMPAIGN' ? this.getUpsellRef.id : '',
            guest_journey_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'GUEST_JOURNEY' ? this.getUpsellRef.id : '',
            reservation_id: this.reservation.id ? this.reservation.id : null,
            payment_mode: '',
            order_type: this.general_data.use_delivery ? this.serve_option.selected.id.toUpperCase() : 'DINE_IN' 
          }

          if(this.isMembershipRewardApplied){
            params.membership_reward_id = this.getMembershipRewardApplied.id
          }

          this.getOutletTrxProducts.forEach(cart=>{
            let is_variant = cart.variants.length > 0
            if(is_variant){
              cart.variants.forEach(variant=>{
                let variant_cart = {
                  id: variant.variant_data.product_ga_pos_id,
                  qty: variant.qty,
                  notes: variant.notes
                }
                params.products.push(variant_cart)
              })
            }else{
              let product_cart = {
                id: cart.product_data.product_ga_pos_id,
                qty: cart.qty,
                notes: cart.notes
              }
              params.products.push(product_cart)
            }
          })

          if(this.serve_option.selected.id == 'delivery'){
            params.payment_mode = 'PAY_IMMEDIATELY'
            params.delivery_lat = this.getOutletTrxDelivery.address.latitude
            params.delivery_long = this.getOutletTrxDelivery.address.longitude
            params.delivery_landmark = this.getOutletTrxDelivery.address.landmark
          }else{
            if(this.general_data.payment_mode != 'PAY_IMMEDIATELY_OR_LATER'){
              params.payment_mode = this.general_data.payment_mode
            }else{
              params.payment_mode = this.payment_mode.data.id
            }
          }
          
        }else{
          let total_amount = Number(this.tx_inquiry.total_payment)+Number(this.payment_surcharge)
          let name = this.$isNotEmpty(this.getOutletTrxCustomerDetail.last_name) ? `${this.getOutletTrxCustomerDetail.first_name} ${this.getOutletTrxCustomerDetail.last_name}` : this.getOutletTrxCustomerDetail.first_name
          params = {
	      		merchant_id: this.getMerchant.id,
	      		tx_order_invoice_id: this.tx_inquiry.id,
	      		amount: Number(total_amount.toFixed(2)),
	      		customer_detail: {
	      			name: name,
	      			email: this.getOutletTrxCustomerDetail.email,
	      			phone_number: this.getOutletTrxCustomerDetail.phone_number
	      		},
	      		payment_details: {
	      			id: this.payment_method.data.id,
	      			payment_method: this.payment_method.data.payment_method,
	      			bank_name: this.payment_method.data.bank_name,
	      			payment_channel: this.payment_method.data.payment_channel
	      		}
	      	}
        }
        return params
      },
      validateDelivery(){
				return new Promise((success,fail)=>{
					this.serve_option.error = ''
					if(this.general_data.use_delivery && this.general_data.payment_mode != 'PAY_LATER'){
						if(this.getOutletTrxDelivery.use){
							let is_map_selected = this.$isNotEmpty(this.getOutletTrxDelivery.address.latitude) && this.$isNotEmpty(this.getOutletTrxDelivery.address.longitude) 
							if(is_map_selected){
								success()
							}else{
								this.serve_option.error = 'Please provide your delivery address'
								fail()
							}
						}else{
							success()
						}
					}else{
						success()
					}
				})
			},
			validatePayment(){
				return new Promise((success,fail)=>{
					this.payment_mode.error = false
					let p_mode = this.general_data.payment_mode
					let valid = true
					if(p_mode != 'PAY_LATER'){
						let is_payment_mode_not_selected = p_mode == 'PAY_IMMEDIATELY_OR_LATER' && !this.payment_mode.data.id
						let is_payment_method = (p_mode == 'PAY_IMMEDIATELY_OR_LATER' && this.payment_mode.data.id == 'PAY_IMMEDIATELY' ) || p_mode == 'PAY_IMMEDIATELY'

						if(is_payment_mode_not_selected){
							this.payment_mode.error = true
							valid = false
						}else if(is_payment_method){
							this.$refs.payment_method.validateForm().then(()=>valid=true).catch(()=>valid=false)
						}
					}
					setTimeout(()=>{
						if(!valid){
							fail()
						}else{
							success()
						}
					},100)
				})
			},
      submitForm() {
        return new Promise((success, fail) => {
          let validateFunc = [
						this.$refs.order_guest_form.validateForm(),
						this.validateDelivery(),
						this.validatePayment()
					]
					if(this.need_guest_data_for_payment) validateFunc.push(this.$refs.payment_guest_form.validateForm()) 
          Promise.all(validateFunc).then(()=>{
            this.pushApiInquiry().then(res=>{
              if(this.need_payment){
                this.tx_inquiry = res.data
                this.pushApiPayment().then(()=>{
                  success()
                }).catch(err=>{
                  this.error_push = err
                  fail()
                })
              }else{
                this.clearCart()
                this.$router.push({
                  name: 'PosPaymentResult',
                  params:{
                    merchant_code: this.getMerchant.code,
                    pos_code: this.pos_code,
                    tx_order_id : res.data.id
                  }
                })
                success()
              }
            }).catch(err=>{
              this.error_push = err
              fail()
            })
          }).catch(err=>{
						if(this.getOutletTrxCustomerDetail.name == '' || (!this.getOutletTrxCustomerDetail.use && this.getOutletTrxTableNumber == '')){
							this.$smoothScroll('add_menu_section')
						}else if(this.serve_option.error != ''){
							this.$smoothScroll('middle_section')
						}else{
							this.$smoothScroll('for-payment-section')
						}
	    			fail()
	    		})
        })
      },
      pushApiInquiry(){
        return new Promise((success,fail)=>{
          let params = this.getApiParams()
          post("CORE_HOTEL","merchant-pos/tx-inquiry",params).then(response=>{
            let res = response.data
            if(res.success){
              success(res)
            }else{
              fail(res.message)
            }
          })
        })
      },
      pushApiPayment(){
        return new Promise((success,fail)=>{
          let params = this.getApiParams('payment')
	      	post("CORE_HOTEL","merchant-pos/tx-payment",params).then(response=>{
            let res = response.data
            if(res.success){
              if(this.payment_method.data.bank_name == 'XENDIT' && this.payment_method.data.payment_method == 'CREDIT_CARD'){
                this.tx_payment = res.payment
                this.tx_payment.general_data = this.general_data
                this.tx_payment.tx_order_id_2 = res.tx_order_id 
                this.payment_in_page = true
                this.$smoothScroll('payment_section')
              }else{
                res.general_data = this.general_data
                this.$proceedPayment('CONCIERGE',this.tx_inquiry,res,this.payment_method.data,'CUSTOM_POS')
              }
              this.resetTrxOutletDelivery()
              success(res)
            }else{
              fail(res.message)
            }
          })
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/Cart.vue